// extracted by mini-css-extract-plugin
module.exports = {"root":"_2RhBE","LinesMenuButtonNSkin":"_3S7Iu","linesMenuButtonNSkin":"_3S7Iu","linkElement":"_1AE5c","wrapper":"_1DPab","label":"_2OJrL"};